import axios from 'axios';

const backend = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_NODE_URL}/api`,
  headers: {
    'ngrok-skip-browser-warning': true,
 
  },
});

export default backend;
